import { collection, doc, getDoc } from "firebase/firestore"

import { COMPANY_COLLECTION } from "../../../const"
import { db } from "../index"

import { getClient } from "./client"
import { HttpsCallableFactory } from "./functions"

import type { CompanyUpsert, Company } from "interfaces/CompanyIF"

const hcf = new HttpsCallableFactory("company")

const getCompany = async () => {
  const client = await getClient()
  const companyCollection = collection(db, COMPANY_COLLECTION)
  const res = await getDoc(doc(companyCollection, client.companyId))

  if (!res.exists()) {
    throw new Error("会社の情報が取得できません")
  }
  return res.data() as Company
}

export const getCompanyDetail = getCompany

export const upsertCompanyDetail = hcf.callFunction<CompanyUpsert, void>(
  "upsertDetail",
)
